import React, { ReactNode } from 'react';
import HelpIcon from '@moda/icons/help-16';
import { Popover, PopoverProps } from '@moda/om';
import './PaymentSummaryRow.scss';

interface Props {
  label: ReactNode;
  value: ReactNode;
  tooltip?: ReactNode;
  tooltipAnchor?: PopoverProps['anchor'];
}

export const PaymentSummaryRow: React.FC<Props> = ({
  label,
  value,
  tooltip,
  tooltipAnchor = 'bottomCenter'
}) => (
  <div className="PaymentSummaryRow">
    <span className="PaymentSummaryRow__label">
      <span>{label}</span>
      {tooltip && (
        <Popover
          anchor={tooltipAnchor}
          content={<div className="PaymentSummaryRow__tooltip">{tooltip}</div>}
        >
          <HelpIcon />
        </Popover>
      )}
    </span>
    <span>{value}</span>
  </div>
);
